// Remembers the user's last explicit export format choice so the download flow
// defaults to it across reloads and sessions. Best-effort; storage may be
// unavailable (private mode, quota).

import { MODEL_FORMAT_EXPORT } from 'Pods/ThreeDStudio/Store/constants'

export const EXPORT_FORMAT_KEY = 'ai_studio_export_format'

const VALID_FORMATS = new Set(Object.values(MODEL_FORMAT_EXPORT))

export const saveExportFormat = (format) => {
  if (!VALID_FORMATS.has(format)) return

  try {
    window.localStorage.setItem(EXPORT_FORMAT_KEY, format)
  } catch (_) {
    // No-op.
  }
}

export const readStoredExportFormat = () => {
  try {
    const stored = window.localStorage.getItem(EXPORT_FORMAT_KEY)
    return VALID_FORMATS.has(stored) ? stored : undefined
  } catch (_) {
    return undefined
  }
}
